// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    
    const { t } = useTranslation();

    return(
        <section id="presentation">
            <div className="container-fluid px-0">
                <div className="row">
                    <div className="col-12 col-lg-6 d-flex order-lg-2">
                        <div className="px-3 py-5 px-lg-5 m-auto">
                            <h1>{t('homePage.presentation.title')}</h1>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para1') as string }}></p>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para2') as string }}></p>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para3') as string }}></p>
                            <Link to={'/chi-siamo'} title={t('homePage.presentation.linkTitle') as string} className="btn-primary ml-auto">
                                <span> {t('homePage.presentation.linkText')}</span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 order-lg-1 px-0">
                        <div className="img-wrapper">
                            <img src="/assets/images/inHome/presentation.webp" alt={t('homePage.presentation.imageAlt') as string} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;